module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Upgrade to Pro","callToActionText":"Let\u0027s upgrade and take advantage of many more Pro features.","btnUpgrade":"See Pro Advantages"},"es":{"title":"Pásate a Pro","callToActionText":"Pásate a Pro y obtén todas las ventajas de las funcionalidades Pro.","btnUpgrade":"Mira los Beneficios de Pro"}}')
  delete Component.options._Ctor
}
